import UniswapXRouterLabel from 'components/RouterLabel/UniswapXRouterLabel'
import { DefaultTheme } from 'lib/styled-components'
import { QuoteMethod, SubmittableTrade } from 'state/routing/types'
import { isUniswapXTrade } from 'state/routing/utils'
import { ThemedText } from 'theme/components'

export default function RouterLabel({ trade, color }: { trade: SubmittableTrade; color?: keyof DefaultTheme }) {
  if (isUniswapXTrade(trade)) {
    return (
      <UniswapXRouterLabel>
        <ThemedText.BodySmall>Canxium X</ThemedText.BodySmall>
      </UniswapXRouterLabel>
    )
  }

  if (trade.quoteMethod === QuoteMethod.CLIENT_SIDE_FALLBACK) {
    return <ThemedText.BodySmall color={color}>Canxium Client</ThemedText.BodySmall>
  }

  return <ThemedText.BodySmall color={color}>Canxium API</ThemedText.BodySmall>
}
